<section class="selectLanguage">
  <section><img src="../../../assets/images/language.svg" alt=""></section>
  <label for="language-select" class="visually-hidden">Label for Translate</label>
  <select name="language-select" id="language-select" [(ngModel)]="selectedLanguage" (change)="selectLanguage($event.target.value)">
    <option value="0" disabled >{{ 'app.select_language' | translate }}</option>
    <option *ngFor="let language of supportedLanguages" [value]="language.language" tabindex="0" [attr.aria-label]="language.title">{{ language.title }}</option>
  </select>
</section>
